import styled from "styled-components";

export const TableWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-family: "Readex Pro", sans-serif;
`;
